import React, { useState, useEffect, useRef } from "react";
import Header from "../ReusedComponents/Header";
import { useHistory, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import Loader from "react-loader-spinner";
import moment from "moment";
import ReplyLeftTab from "./ReplyLeftTab";
import TMRHistory from "./TMRHistory";
import TMUserTrack from "./TMUserTrack";
import { SendNotification } from "./SendNotification";
import RequestTicket from "../User/RequestTicket";
import TicketReport from "../User/TicketReport";
import { cryptoED } from "./cryptoED";
import { useReactToPrint } from "react-to-print";
import useAutosizeTextArea from "./useAutosizeTextArea";
import { DecryptED } from "../../DecryptJS/Decrypt";

export default function AdminTicket(props) {
  // console.log(props.userType);
  const history = useHistory();
  const location = useLocation();
  // console.log(location.pathname);
  const [ticketCreator, setTicketCreator] = useState()
  const [ticketAssigned, setTicketAssigned] = useState()

  const { sid, uid, ticket_id, ssid } = useParams();
  const locState = history.location.state || {};
  const name = locState.username || "Unknown";
  const [Reply, setReply] = useState(false);
  const [ReplyClose, setReplyClose] = useState(false);
  const [Details, setDetails] = useState(false);
  const [ReplyData, setReplyData] = useState([]);
  const [Historydata, setHistorydata] = useState("");
  const [TicketDetails, setTicketDetails] = useState("");
  const [Stafftype, setStafftype] = useState("");
  const [StaffDetails, setStaffDetails] = useState("");
  const [selectedOption, setSelectedOption] = useState("Chat");
  const [UserDetails, setUserDetails] = useState("");

  const [value, setValue] = useState("");

  const chatRef = useRef(null);

  const generatePdf = useReactToPrint({
    content: () => chatRef.current,
    documentTitle: `chats ${moment().format("DD/MM/YYYY")}`,
  });

  const textAreaRef = useRef(null);

  useAutosizeTextArea(textAreaRef.current, value);

  const handleChange = (evt) => {
    const val = evt.target.value;

    setValue(val);
  };

  useEffect(() => {
    axios
      .post("https://topschool.prisms.in/rest/index.php/user_list.json?", {
        fun_name: "AUserInfo",
        sid: ssid || sid,
        u_id: uid,
      })
      .then((res) => {
        setUserDetails(res.data);
      });
    axios
      .post("https://topschool.prisms.in/rest/index.php/user_list.json?", {
        fun_name: "GetStaffDetails",
        sid: sid,
      })
      .then((res) => {
        var a = [];
        var staffList = res.data && res.data.Staff_Details ? res.data.Staff_Details : [];
        staffList.map((i) => {
          if (a.length > 0 ? a[0][i.type] === undefined : true) {
            a.length === 0 ? a.push({ [i.type]: [i] }) : (a[0][i.type] = [i]);
          } else {
            a[0][i.type].push(i);
          }
        });
        if (a.length > 0) {
          setStafftype(Object.keys(a[0]));
          setStaffDetails(a[0]);
        } else {
          setStafftype([]);
          setStaffDetails({});
        }
      });

    const GetTicketCreator = async () => {
      await axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/tscommon/tickets/creator",
        data: {
          sid: DecryptED(sid),
        },
      })
        .then((res) => {
          const val = res.data[0].values;
          const newVal = val.split(',');
          if (newVal.length >= 2) {
            console.log(newVal[0])
            console.log(newVal[1])
            setTicketCreator(newVal[0])
            setTicketAssigned(newVal[1])
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    GetTicketCreator()
  }, []);

  useEffect(() => {
    setHistorydata("");
    setReplyData("");
    setTicketDetails("");
    setSelectedOption("Chat");
    getTicketCreated(locState.id || ticket_id);
    getTicketHistory(locState.id || ticket_id);
  }, [ticket_id]);

  function getTicketHistory(id) {
    axios
      .post("https://topschool.prisms.in/rest/index.php/user_list.json?", {
        fun_name: "GetTicketHistory",
        sid: sid,
        ticket_id: id,
      })
      .then((res) => {
        var history = res.data && res.data.Ticket_History ? res.data.Ticket_History : [];
        setReplyData([...history].reverse());
        setHistorydata([...history].reverse());
      });
  }

  function getTicketCreated(id) {
    axios
      .post("https://topschool.prisms.in/rest/index.php/user_list.json?", {
        fun_name: "GetTicketCreate",
        sid: sid,
        id: id,
      })
      .then((res) => {
        setTicketDetails(res.data.Tickets);
        // ScrollBottom(1000)
      });
  }

  function ScrollBottom(time) {
    setTimeout(() => {
      if (document.getElementById("TMChat") !== null) {
        document.getElementById("TMChat").scrollBehavior = "smooth";
        document.getElementById("TMChat").scrollTop = document.getElementById(
          "TMChat"
        ).scrollHeight;
      }
    }, time);
  }

  function updateTicket(data) {
    setTicketDetails("");
    const d = { nooffiles: 0, ...TicketDetails[0], ...data.data };
    if (data.data.status === "Closed") {
      d.closed_by = name;
      d.staffClosed_uid = uid;
    }
    const fm = new FormData();
    if (data.data.file) {
      for (let i = 1; i < data.data.nooffiles; i++) {
        fm.append("file" + i, d.file[i]);
      }
    }
    if (d.nooffiles === 0) {
      Object.keys(d).map((i) => {
        if (i !== "duedate1") {
          fm.append(i === "school" ? "schoolname" : i, d[i]);
        }
      });
    } else {
      Object.keys(d).map((i) => {
        if (i !== "duedate1") {
          if (i === "file") {
            fm.append("file0", d.file[0]);
          } else {
            fm.append(i === "school" ? "schoolname" : i, d[i]);
          }
        }
      });
    }
    fm.append("fun_name", "Update_Ticket_Create");
    fm.append("sid", sid);
    const insertHistory = axios.post(
      "https://topschool.prisms.in/rest/index.php/user_list.json?",
      {
        fun_name: "TicketHistoryInsert",
        sid: sid,
        ticket_id: locState.id || ticket_id,
        date: moment().format("YYYY-MM-DD HH:mm:ss"),
        committee: TicketDetails[0].committee,
        remark_reply: "",
        reply: 0,
        staff: name,
        status:
          data.data.status !== undefined
            ? data.data.status
            : TicketDetails[0].status,
        history: `${name} updated the ticket`,
        history_details: data.history,
        uid: uid,
        is_sadmin: ssid ? 1 : 0,
      }
    );
    if (d.status === "Closed") {
      fm.delete("closed_tickets");
      axios
        .post("https://topschool.prisms.in/rest/index.php/user_list.json?", {
          fun_name: "GetTicketHistory",
          sid: sid,
          staffClosed_uid: uid,
        })
        .then((res) => {
          fm.append(
            "closed_tickets",
            res.data.Ticket_History[0].closed_tickets
          );
          const updateticket = axios.post(
            "https://topschool.prisms.in/rest/index.php/user_list.json?",
            fm
          );
          axios.all([updateticket, insertHistory]).then(() => {
            SendNotification({
              sid: sid,
              userid: TicketDetails[0].uid || TicketDetails[0].staff_id,
              ticket_id: TicketDetails[0].id,
              action: `${name} closed your ticket`,
            });
            getTicketCreated(locState.id || ticket_id);
            getTicketHistory(locState.id || ticket_id);
          });
        });
    } else {
      const updateticket = axios.post(
        "https://topschool.prisms.in/rest/index.php/user_list.json?",
        fm
      );
      axios.all([updateticket, insertHistory]).then(() => {
        if (TicketDetails[0].staff !== data.data.staff) {
          SendNotification({
            sid: sid,
            userid: TicketDetails[0].uid || TicketDetails[0].staff_id,
            ticket_id: TicketDetails[0].id,
            action: `${name} assigned a ticket to you`,
          });
        }
        getTicketCreated(locState.id || ticket_id);
        getTicketHistory(locState.id || ticket_id);
      });
    }
  }

  function InsertTicketHistory(reply, shouldClose) {
    var closeTicket = shouldClose === true;
    if (closeTicket) {
      updateTicket({
        data: { status: "Closed" },
        history: `Status changed from ${TicketDetails[0].status} to Closed`,
      });
    }
    axios
      .post("https://topschool.prisms.in/rest/index.php/user_list.json?", {
        fun_name: "TicketHistoryInsert",
        sid: sid,
        ticket_id: locState.id || ticket_id,
        date: moment().format("YYYY-MM-DD HH:mm:ss"),
        committee: TicketDetails[0].committee,
        remark_reply: reply,
        reply: 1,
        staff: name,
        status: closeTicket ? "Closed" : TicketDetails[0].status,
        history: closeTicket ? `${name} replied and closed ticket` : `${name} replied on ticket`,
        history_details: "",
        uid: uid,
        is_sadmin: ssid ? 1 : 0,
      })
      .then(() => {
        SendNotification({
          sid: sid,
          userid: TicketDetails[0].uid || TicketDetails[0].staff_id,
          ticket_id: TicketDetails[0].id,
          action: closeTicket
            ? `${name} replied and closed your ticket`
            : `${name} replied on your ticket`,
        });
        getTicketHistory(locState.id || ticket_id);
      });
  }

  function NavigatorwithID(id) {
    setHistorydata("");
    setReplyData("");
    setTicketDetails("");
    setSelectedOption("Chat");
    ssid
      ? history.push(
        `/tickets/superadmin/details/${ssid}/${sid}/${uid}/${id}`,
        { ...history.location.state, id: id }
      )
      : history.push(`/tickets/${props.userType}/details/${sid}/${uid}/${id}`, {
        ...history.location.state,
        id: id,
      });
  }
  // useEffect(()=>{console.log(ReplyData)},[ReplyData])

  // console.log(ReplyData)

  return (
    <>
      <div
        className="totalTicketingModule"
        style={{ overflow: "hidden", height: "100vh" }}
      >
        <Header
          title={props.title}
          options={props.options}
          ChangePage={(params) =>
            history.push(
              params.data !== undefined ? params.url : params.url,
              params.data
            )
          }
        />
        {ReplyData === "" ||
          TicketDetails === "" || !TicketDetails || !TicketDetails[0] ||
          Stafftype === "" ||
          StaffDetails === "" ||
          UserDetails === "" ? (
          <div className="TMLoader">
            <Loader type="Puff" color="#1e5597" height={70} width={70} />
          </div>
        ) : (
          <div>
            <div className="TMTicketDivResponsive">
              <div className="TMDetailsMainDiv">
                <div className="TMDetailsLeft">
                  <div className="TMDetailsLeftTop">
                    <ReplyLeftTab
                      data={TicketDetails}
                      updateTicket={(params) => {
                        updateTicket(params);
                      }}
                      userType={props.userType}
                      Stafftype={Stafftype}
                      StaffDetails={StaffDetails}
                      NavigatorwithID={NavigatorwithID}
                      sid={sid}
                      parentId={ticket_id}
                    />
                  </div>
                </div>
                <div className="TMDetailsRight">
                  <div style={{}}>
                    <button
                      onClick={() => history.goBack()}
                      style={{
                        background: "#1e5597", color: "#fff", border: "none", borderRadius: "6px",
                        padding: "5px 14px", fontSize: "12px", fontWeight: 600, cursor: "pointer",
                        marginBottom: "8px", fontFamily: "inherit",
                      }}
                    >← Back</button>
                    <span
                      className="TMTR__Title"
                      style={{ fontSize: "20px", fontWeight: "bold", marginLeft: "10px" }}
                    >
                      #{TicketDetails[0].id} - {TicketDetails[0].title}
                    </span>
                    <br />
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "grey",
                      }}
                    >
                      Created on{" "}
                      {moment(TicketDetails[0].date).format(
                        "DD-MM-YYYY hh:mm A"
                      )}
                    </span>
                    <div className="TMDetailsReplyButtons">
                      <div
                        style={{
                          borderBottom:
                            selectedOption === "Chat"
                              ? "3px solid rgb(30, 85, 151)"
                              : "3px solid white",
                        }}
                        onClick={() => {
                          setSelectedOption("Chat");
                        }}
                      >
                        Chat
                      </div>
                      {props.userType === "admin" ||
                        props.userType === "user" ? (
                        <>
                          <div
                            style={{
                              borderBottom:
                                selectedOption === "History"
                                  ? "3px solid rgb(30, 85, 151)"
                                  : "3px solid white",
                            }}
                            onClick={() => {
                              setSelectedOption("History");
                            }}
                          >
                            History
                          </div>
                        </>
                      ) : (
                        <div
                          style={{
                            borderBottom:
                              selectedOption === "Track"
                                ? "3px solid rgb(30, 85, 151)"
                                : "3px solid white",
                          }}
                          onClick={() => {
                            setSelectedOption("Track");
                          }}
                        >
                          Track
                        </div>
                      )}
                      <div
                        style={{
                          borderBottom:
                            selectedOption === "Tickets"
                              ? "3px solid rgb(30, 85, 151)"
                              : "3px solid white",
                        }}
                        onClick={() => {
                          setSelectedOption("Tickets"); /* ScrollBottom(1000) */
                        }}
                      >
                        Child Tickets
                      </div>
                      <div
                        className="TMMobileDetailsButton"
                        onClick={() => {
                          setDetails(true);
                        }}
                      >
                        Details
                      </div>
                    </div>
                  </div>
                  {selectedOption === "Chat" ? (
                    <>
                      <div
                        id="TMChat"
                        style={{ overflow: "auto", flex: 1, padding: "10px 15px", display: "flex", flexDirection: "column" }}
                        ref={chatRef}
                      >
                        {/* Description fieldset */}
                        <fieldset style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "10px", marginBottom: "10px" }}>
                          <legend style={{ fontSize: "11px", fontWeight: 700, color: "#888", padding: "0 6px", textTransform: "uppercase" }}>Description</legend>
                          <p style={{ margin: 0, color: "#4a6080", fontSize: "12px", lineHeight: 1.5, maxHeight: "60px", overflowY: "auto" }}>{TicketDetails[0].description}</p>
                        </fieldset>

                        {/* Chat fieldset */}
                        <fieldset style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "10px", marginBottom: "10px", flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                          <legend style={{ fontSize: "11px", fontWeight: 700, color: "#888", padding: "0 6px", textTransform: "uppercase" }}>Chat</legend>
                          <div style={{ flex: 1, overflowY: "auto", background: "#f4f7fb", borderRadius: "8px", padding: "10px 8px", border: "1px solid #e2eaf4" }}>
                            {(function () {
                              var replies = Array.isArray(ReplyData) ? ReplyData.filter(function (h) {
                                return h.reply === "1" && h.staff !== "User" && h.remark_reply;
                              }) : [];
                              if (replies.length === 0) {
                                return <div style={{ textAlign: "center", padding: "20px", color: "#94a3b8", fontSize: "13px" }}>No messages yet</div>;
                              }
                              var grouped = {};
                              replies.forEach(function (h) {
                                var dk = moment(h.date, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY");
                                if (!grouped[dk]) grouped[dk] = [];
                                grouped[dk].push(h);
                              });
                              return Object.keys(grouped).map(function (dk, gi) {
                                return (
                                  <div key={gi}>
                                    <div style={{ textAlign: "center", margin: "8px 0 12px" }}>
                                      <span style={{ background: "#e2eaf4", color: "#4a6080", fontSize: "11px", fontWeight: 700, padding: "4px 14px", borderRadius: "8px" }}>{dk}</span>
                                    </div>
                                    {grouped[dk].map(function (h, idx) {
                                      var isMe = h.uid === cryptoED(uid);
                                      return (
                                        <div key={idx} style={{ display: "flex", justifyContent: isMe ? "flex-end" : "flex-start", marginBottom: "8px" }}>
                                          <div style={{ maxWidth: "75%" }}>
                                            {!isMe && <div style={{ fontSize: "11px", fontWeight: 700, color: "#1b5499", marginBottom: "2px" }}>{h.staff}</div>}
                                            <div style={{
                                              background: isMe ? "#dbeafe" : "#fff",
                                              borderRadius: isMe ? "10px 0 10px 10px" : "0 10px 10px 10px",
                                              padding: "8px 12px",
                                              border: isMe ? "1px solid #93c5fd" : "1px solid #e2eaf4",
                                              minWidth: "80px",
                                            }}>
                                              <div style={{ fontSize: "13px", color: "#0b2545", wordBreak: "break-word", lineHeight: 1.4 }}>{h.remark_reply}</div>
                                              <div style={{ fontSize: "10px", color: "#94a3b8", textAlign: "right", marginTop: "4px" }}>{moment(h.date, "YYYY-MM-DD HH:mm:ss").format("hh:mm A")}</div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              });
                            })()}
                          </div>
                        </fieldset>
                      </div>

                      {/* Add Reply - fixed at bottom outside scroll */}
                      {TicketDetails[0].status !== "Closed" ? (
                        <div style={{ padding: "8px 15px", borderTop: "1px solid #e2eaf4", background: "#fff", flexShrink: 0 }}>
                          <fieldset style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "10px", margin: 0, boxSizing: "border-box", overflow: "hidden" }}>
                            <legend style={{ fontSize: "11px", fontWeight: 700, color: "#888", padding: "0 6px", textTransform: "uppercase" }}>Add Reply</legend>
                            <div style={{ display: "flex", gap: 0, marginBottom: "8px" }}>
                              <button
                                onClick={() => { setReplyClose(false); }}
                                style={{
                                  flex: 1, padding: "9px", border: "1px solid #1e5597", fontSize: "13px", fontWeight: 700, cursor: "pointer",
                                  background: !ReplyClose ? "#1e5597" : "#f5f5f5", color: !ReplyClose ? "#fff" : "#4a6080",
                                  borderRadius: "8px 0 0 8px", fontFamily: "inherit", textAlign: "center",
                                }}
                              >Reply</button>
                              <button
                                onClick={() => { setReplyClose(true); }}
                                style={{
                                  flex: 1, padding: "9px", border: "1px solid #ddd", fontSize: "13px", fontWeight: 700, cursor: "pointer",
                                  background: ReplyClose ? "#1e5597" : "#f5f5f5", color: ReplyClose ? "#fff" : "#4a6080",
                                  borderRadius: "0 8px 8px 0", fontFamily: "inherit", textAlign: "center",
                                }}
                              >Internal Note</button>
                            </div>
                            <textarea
                              id="replytext"
                              ref={textAreaRef}
                              placeholder="Write your reply to this ticket..."
                              value={value}
                              onChange={handleChange}
                              rows={1}
                              onKeyDown={(e) => {
                                if (e.ctrlKey && e.key === "Enter" && value.trim()) {
                                  InsertTicketHistory(value, false);
                                  setReplyData("");
                                  setValue("");
                                }
                              }}
                              className="tr-reply-textarea"
                            />
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "6px" }}>
                              <span style={{ fontSize: "10px", color: "#999" }}>Ctrl+Enter to submit</span>
                              <div style={{ display: "flex", gap: "8px" }}>
                                <button
                                  onClick={() => { setValue(""); }}
                                  style={{ padding: "8px 16px", borderRadius: "8px", border: "1px solid #ddd", background: "#fff", color: "#4a6080", fontSize: "13px", fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}
                                >✕ Close</button>
                                <button
                                  disabled={!value.trim()}
                                  onClick={() => {
                                    if (value.trim()) {
                                      InsertTicketHistory(value, true);
                                      setReplyData("");
                                      setValue("");
                                    }
                                  }}
                                  style={{
                                    padding: "8px 16px", borderRadius: "8px", border: "none",
                                    background: value.trim() ? "#dc2626" : "#ccc", color: "#fff",
                                    fontSize: "13px", fontWeight: 700, cursor: value.trim() ? "pointer" : "not-allowed",
                                    fontFamily: "inherit",
                                  }}
                                >📩 Reply & Close</button>
                                <button
                                  disabled={!value.trim()}
                                  onClick={() => {
                                    if (value.trim()) {
                                      InsertTicketHistory(value, false);
                                      setReplyData("");
                                      setValue("");
                                    }
                                  }}
                                  style={{
                                    padding: "8px 20px", borderRadius: "8px", border: "none",
                                    background: value.trim() ? "#28a745" : "#ccc", color: "#fff",
                                    fontSize: "13px", fontWeight: 700, cursor: value.trim() ? "pointer" : "not-allowed",
                                    fontFamily: "inherit",
                                  }}
                                >💬 Send Reply</button>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                      ) : (
                        <div style={{ padding: "10px 15px", borderTop: "1px solid #e2eaf4" }}>
                          <div style={{ textAlign: "center", padding: "14px", background: "#f0fdf4", borderRadius: "8px", border: "1px solid #86efac", color: "#16a34a", fontWeight: 700, fontSize: "13px" }}>
                            Ticket Closed
                          </div>
                        </div>
                      )}
                    </>
                  ) : selectedOption === "History" ? (
                    <TMRHistory data={Historydata} />
                  ) : selectedOption === "Track" ? (
                    <TMUserTrack data={ReplyData} />
                  ) : selectedOption === "Child" ? (
                    <>
                      <RequestTicket
                        props={"admin"}
                        userData={UserDetails}
                        staffData={Stafftype}
                        staffDetails={StaffDetails}
                        parentId={locState.id || ticket_id}
                        onCreateNew={NavigatorwithID}
                      />
                      <div
                        className="TMDetailsRightButtons"
                        style={{ padding: "10px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexWrap: "wrap",
                          }}
                        >
                          <div
                            className="TMSubmitButton"
                            onClick={() => {
                              setSelectedOption("Tickets");
                            }}
                          >
                            <b>View Child Tickets</b>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : selectedOption === "Tickets" ? (
                    <>
                      <style>{`
                        .tk-child-wrap {
                          position: relative;
                          padding-bottom: 70px;
                        }
                        .tk-child-list {
                          margin: 10px;
                          border: 1px solid #e2eaf4;
                          border-radius: 8px;
                          overflow: hidden;
                          background: #fff;
                        }
                        .tk-child-list .welcome-bar,
                        .tk-child-list .TMHeader,
                        .tk-child-list .view-toggle-bar {
                          display: none !important;
                        }
                        .tk-child-list .main-area {
                          min-height: 0 !important;
                          max-height: 500px !important;
                          height: 500px !important;
                          overflow-y: auto !important;
                          overflow-x: hidden !important;
                          display: block !important;
                          background: transparent !important;
                        }
                        .tk-child-list .board-area {
                          width: 100% !important;
                          height: auto !important;
                          flex: none !important;
                        }
                        .tk-child-list .kanban-board {
                          min-height: 0 !important;
                          max-height: none !important;
                          height: auto !important;
                          padding: 10px !important;
                          overflow: visible !important;
                          display: grid !important;
                          grid-template-columns: 1fr 1fr;
                          gap: 10px;
                        }
                        .tk-child-list .kanban-column {
                          min-width: 0 !important;
                        }
                        .tk-child-list .list-view-wrap {
                          min-height: 0 !important;
                          max-height: 500px !important;
                          height: 500px !important;
                          padding: 10px !important;
                          overflow-y: auto !important;
                        }
                        @media (max-width: 768px) {
                          .tk-child-list .main-area,
                          .tk-child-list .list-view-wrap {
                            max-height: 400px !important;
                            height: 400px !important;
                          }
                        }
                        @media (max-width: 600px) {
                          .tk-child-list .kanban-board {
                            grid-template-columns: 1fr !important;
                          }
                          .tk-child-list .main-area,
                          .tk-child-list .list-view-wrap {
                            max-height: 350px !important;
                            height: 350px !important;
                          }
                        }
                        .tk-child-footer {
                          padding: 12px;
                          border-top: 2px solid #e2eaf4;
                          background: #f8fafc;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex-shrink: 0;
                        }
                        .tk-child-btn {
                          background: #1e5597;
                          color: #fff;
                          padding: 10px 28px;
                          border-radius: 8px;
                          font-weight: 700;
                          cursor: pointer;
                          box-shadow: 0 2px 8px rgba(30,85,151,0.3);
                          font-size: 14px;
                          white-space: nowrap;
                          transition: all 0.2s;
                        }
                        .tk-child-btn:hover {
                          background: #16447a;
                          transform: translateY(-1px);
                        }
                        @media (max-width: 768px) {
                          .tk-child-wrap {
                            height: calc(100vh - 160px);
                            min-height: 300px;
                          }
                          .tk-child-list {
                            margin: 6px;
                          }
                          .tk-child-footer {
                            padding: 10px;
                          }
                          .tk-child-btn {
                            padding: 8px 20px;
                            font-size: 13px;
                          }
                        }
                        @media (max-width: 480px) {
                          .tk-child-wrap {
                            height: calc(100vh - 140px);
                            min-height: 250px;
                          }
                          .tk-child-list {
                            margin: 4px;
                            border-radius: 6px;
                          }
                          .tk-child-footer {
                            padding: 8px;
                          }
                          .tk-child-btn {
                            padding: 8px 16px;
                            font-size: 12px;
                            width: 100%;
                            text-align: center;
                          }
                        }
                      `}</style>
                      <div className="tk-child-wrap">
                        <div className="tk-child-list">
                          <TicketReport
                            props={"admin"}
                            TicketData={locState.TicketData}
                            parentId={locState.id || ticket_id}
                            setID={NavigatorwithID}
                          />
                        </div>
                        <div
                          style={{
                            padding: "12px",
                            borderTop: "2px solid #e2eaf4",
                            background: "#f8fafc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            zIndex: 10,
                          }}
                        >
                          <div
                            className="tk-child-btn"
                            onClick={() => {
                              setSelectedOption("Child");
                            }}
                          >
                            <b>+ Create Child Ticket</b>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
            <div
              className="TMDetailsDetailsPopup"
              style={{ width: Details ? "100%" : "0px", zIndex: 100 }}
            >
              <Header
                title={props.title}
                options={props.options}
                ChangePage={(params) =>
                  history.push(
                    params.data !== undefined ? params.url : params.url,
                    params.data
                  )
                }
              />
              <div
                className="TMDetailsCloseButton"
                onClick={() => {
                  setDetails(false);
                }}
              >
                ✖
              </div>
              <div style={{ overflow: "scroll", height: "100vh" }}>
                <div
                  className="TMDetailsLeftTop"
                  style={{ width: "90%", padding: "10px" }}
                >
                  <ReplyLeftTab
                    data={TicketDetails}
                    updateTicket={(params) => {
                      updateTicket(params);
                    }}
                    userType={props.userType}
                    Stafftype={Stafftype}
                    NavigatorwithID={NavigatorwithID}
                    StaffDetails={StaffDetails}
                    sid={sid}
                    parentId={ticket_id}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
